import {Component, OnInit, Input, ViewEncapsulation, EventEmitter, Output} from "@angular/core";
import {AppSettings} from "../../../../app.settings";
import {Settings} from "../../../../app.settings.model";
import {MenuService} from "../menu.service";
import {MakeAPaymentDialogComponent} from "../../../../pages/aps/make-a-payment-dialog/make-a-payment-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {RequestServiceDialogComponent} from "../../../../pages/summary/request-service-dialog/request-service-dialog.component";
import {RequestDeliveryDialogComponent} from "../../../../pages/summary/request-delivery-dialog/request-delivery-dialog.component";

@Component({
    selector: "app-vertical-menu",
    templateUrl: "./vertical-menu.component.html",
    styleUrls: ["./vertical-menu.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [MenuService],
})
export class VerticalMenuComponent implements OnInit
{
    @Input("menuItems") menuItems;
    @Input("menuParentId") menuParentId;
    @Output() menuItemClicked = new EventEmitter<number>();

    @Input() isCustSelected: boolean; // disabled sidenav if company login and no customer selected yet
    @Input() isCustomerSearchActive: boolean;
    disabledMenu: string = "Please use 'Customer Search' to select a customer and enable the navigation menu.";

    parentMenu: Array<any>;
    public settings: Settings;

    constructor(
        public appSettings: AppSettings,
        public menuService: MenuService,
        public dialog: MatDialog,
    )
    {
        this.settings = this.appSettings.settings;
    }

    ngOnInit()
    {
        this.parentMenu = this.menuItems.filter(item => item.parentId === this.menuParentId);
    }


    onClick(menuId: number): void
    {
        const dialogMap = {
            9: MakeAPaymentDialogComponent,
            10: RequestDeliveryDialogComponent,
        };

        const dialogComponent = dialogMap[menuId];
        if (dialogComponent)
        {
            this.dialog.open(dialogComponent, {
                width: menuId === 9 ? '600px' : '400px',
                minHeight: menuId === 9 ? '400px' : undefined,
                maxHeight: '90%',
                maxWidth: '90%',
                disableClose: true,
                restoreFocus: false,
            });
        }

        this.menuService.toggleMenuItem(menuId);
        this.menuService.closeOtherSubMenus(this.menuItems, menuId);
        this.menuItemClicked.emit(menuId);        
    }

    public getMenuItemClasses(menu: any): { [key: string]: boolean }
    {
        return {
            'gray-text': (!this.isCustSelected || this.isCustomerSearchActive) && menu.title !== 'Customer Search'
        };
    }

}
